import { createRequestActionsSet } from "@store/shared/requestState"

export const putItem = createRequestActionsSet("inventory", "PUT_ITEM")
export const deleteItem = createRequestActionsSet("inventory", "DELETE_ITEM")
export const fetchInventory = createRequestActionsSet("inventory", "FETCH_INVENTORY")
